import React from 'react';
import { Users, ShieldCheck, Award, MapPin, FileText, Heart } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Users,
  ShieldCheck,
  Award,
  MapPin,
  FileText,
  Heart
};

export const WhyChooseUs = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
            Why Choose <span className="text-primary">Birchfield Roofing</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            We're more than just a roofing company—we're your neighbors committed to
            protecting your home with integrity, quality, and unmatched service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="border-2 hover:border-primary transition-all duration-300 hover:shadow-lg"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-6">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold text-secondary mb-3">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e"
              alt="Birchfield Roofing Team"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-secondary">
              Family Values, Professional Results
            </h3>
            <p className="text-lg text-muted-foreground leading-relaxed">
              At Birchfield Roofing LLC, we bring family values to every project. As a
              family-owned and operated business, we understand the importance of
              protecting your home—because we treat it like our own.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              With years of experience serving Central Florida, we've built our
              reputation on quality craftsmanship, honest pricing, and customer
              satisfaction. We're fully licensed and insured, giving you peace of mind
              with every project.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                  <ShieldCheck className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-bold text-secondary">Licensed</p>
                  <p className="text-sm text-muted-foreground">State Certified</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                  <ShieldCheck className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-bold text-secondary">Insured</p>
                  <p className="text-sm text-muted-foreground">Fully Protected</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
